import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { companyBaseInfo } from '../../../server';
import { changeTabFavIcon } from '../../../utils/helpers';
import LogInForm from './components/LogInForm';

const Logo = `${process.env.PUBLIC_URL}/img/dolceJou.png`;

const LogIn = props => {
  const { isAuthenticated, allowSystemAccess } = props;
  const { location } = props;
  const { state } = location;

  // const [companyDetal, setCompanyDetail] = useState({});

  useEffect(() => {
    (async () => {
      await companyBaseInfo()
        .then(data => {
          changeTabFavIcon(data);
          //  setCompanyDetail(data);
          document.title = `${data.company_name}`;
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    })();
  }, []);

  if (isAuthenticated) {
    return (
      <Redirect
        to={
          allowSystemAccess
            ? {
                pathname: state ? state.from.pathname : '/',
                search: state ? state.from.search : '',
                state: state ? state.from.state : null,
              }
            : {
                pathname: state ? state.from.pathname : '/pages/user/profile', // if user is not allowed for system then this route will work
              }
        }
      />
    );
  }

  return (
    <div className="account">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head">
            <h3 className="title__login">Sign In</h3>
          </div>
          <LogInForm />
        </div>
        <div className="account__card bg__primary">
          <div className="welcome__section">
            <div className="logo__img">
              <img src={Logo} alt="" id="logo" />
            </div>
            <div className="login__welcome mt-2">
              <h3>Experience streamlined productivity</h3>
            </div>
          </div>
          <div className="">
            <p className="m-0 text-white text-center"> For technical support</p>
            <p className="m-0 text-white text-center">
              Support@beyonderissolutions.com
            </p>
          </div>
        </div>
      </div>
      <div className="d-flex fixed-bottom font-16 mb-2 ml-3 ">
        <p className="text-muted mt-1">
          Powered by
          <a
            className="text-muted ml-1"
            href="https://beyonderissolutions.com/"
            target="blank"
          >
            Beyond Eris Solutions
          </a>
        </p>
        <p className="text-right text-muted mt-0">&#169;</p>
      </div>
    </div>
  );
};

LogIn.propTypes = {
  isAuthenticated: PropTypes.bool,
  allowSystemAccess: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }),
};

LogIn.defaultProps = {
  isAuthenticated: false,
  location: {
    state: {
      pathname: '',
    },
  },
};

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    allowSystemAccess: state.auth.user
      ? state.auth.user.profile.system_access
      : false,
  };
};

export default connect(mapStateToProps, null)(LogIn);
